import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import {translate} from '@jsverse/transloco';
@Component({
    selector: 'app-bookmarks',
    templateUrl: './bookmarks.component.html',
    styleUrls: ['./bookmarks.component.scss'],
    standalone: false
})
export class BookmarksComponent implements OnInit {

  bookmarkList: any[];

  constructor(public dateTimeFormatService: DateTimeFormatService, private router: Router,
    private authService: AuthService, private sidenavService: SidenavService,
    private customToastrService: CustomToastrService) { }

  ngOnInit(): void {
    this.bookmarkList = JSON.parse(localStorage.getItem('bookmarks'));
  }

  deleteClick(data): void {
    this.bookmarkList = this.bookmarkList.filter(item => item.id !== data.id);
    localStorage.setItem('bookmarks', JSON.stringify(this.bookmarkList));
    this.sidenavService.bookmarkDelete.next(data);
    setTimeout(() => {
        const message = translate('INSTANCE_LIST.BOOKMARK_DELETED');
        const title = translate('INSTANCE_LIST.BOOKMARK');
        this.customToastrService.successMessage(message, title);
    }, 500);
  }

  rowClick(data): void {
    if (data.type === 'instance') {
      this.sidenavService.closeRightSidenav();
      this.router.navigateByUrl('/', {skipLocationChange: true})
      .then(()=>this.router.navigate([this.authService.principal.provider, data.type, data.id]));
    }
  }

}
